<div class="auth-wrapper">
	<div class="auth-shell">
		<div class="auth-container">
			
			<div class="overlay-container">
				<div class="overlay">
					<div class="overlay-panel overlay-right">
						<h1>Nova Senha</h1>
						<p>Insira e confirme sua nova senha para recuperar o acesso.</p>
					</div>
				</div>
			</div>

			<div class="form-container sign-in-container" *ngIf="!subscription">
				<form class="auth-form" [formGroup]="formGroup">
					<img class="logo" src="assets/img/logo-sistema.png" />
					<h2>Alterar Senha</h2>
					<span class="sub-text">Crie uma nova senha</span>

					<div class="custom-input-group">
						<input type="password" class="custom-input" formControlName="pass1" placeholder="Nova senha" />
					</div>
					<div class="custom-input-group">
						<input type="password" class="custom-input" formControlName="pass2" placeholder="Confirme a nova senha" />
					</div>
					
					<button type="submit" class="submit" [disabled]="formGroup.invalid || !equalPassword()" (click)="onLogin()">
						Salvar Nova Senha
					</button>
					<a class="forgot-link" (click)="onVoltar()">Voltar ao Login</a>
				</form>
			</div>
			
			<div *ngIf="subscription" class="auth-loading-container">
				<mat-spinner [diameter]="48"></mat-spinner>
			</div>

		</div>
	</div>
</div>